<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Sociological Association</h3></header>
            <img src="assets/img/sociological_association.jpg">
            <hr>
            <p>
              The Sociological Association of the University of Ruhuna was set up on July 25, 1990 at the Department of
              History and Sociology. At present, this Association is registered under the Department of Sociology.
              Membership is open to the students who follow the honors degree in Sociology and the other students who
              follow the general degree. From the beginning, this association has initiated many programmes such as
              publishing student journals and conducting workshops and cultural events
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>The Sociological Association aims to facilitate sociological research and promotes network of
                communication to all who are interested in the discipline. This is evidenced by the successful
                activities of the publication of student journal “Vimarsha”.
              </li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Office Bearers</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <a href="#">Chief Advisor</a>
                    <figure class="professor-description">
                      Dr.Suranjith Gunasekara <br>
                      Head of the Department
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Treasurer</b>
                    <figure class="professor-description">Dr. M.A.C.G Wijesundara</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>President</b>
                    <figure class="professor-description">Mr. Akila Sandaruwan</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice President</b>
                    <figure class="professor-description">Ms. Umansha Kavindi</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">Ms. Dulshani Martinus</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Deputy Secretary</b>
                    <figure class="professor-description">Mr. Dhanushka Sandaruwan</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Treasurer</b>
                    <figure class="professor-description">Chamathi Serasinghe</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Treasurer</b>
                    <figure class="professor-description">
                      Ms. Virasha Godakanda <br>
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Editor</b>
                    <figure class="professor-description">
                      Kasuni Pramodha 8<br>
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Committee Members</b>
                    <figure class="professor-description">
                      Ms. Achala Upendra Rodrigo<br>
                      Ms. Harsha Premamali<br>
                      Ms. Nimasha Madumali
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
